import BACardSet from './BACardSet';
import BelarusBACardSet from './BelarusBACardSet';
import { APP_TYPES } from '../../../../../config/constants';

export default process.env.REACT_APP_APP_TYPE === APP_TYPES.BELARUS ? BelarusBACardSet : BACardSet;
